import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { DiscountCodeBenefitMetadataExtension } from './extension/discount_code-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('discount_code').add(BenefitMetadataExtensionInterface, new DiscountCodeBenefitMetadataExtension()).build(),
);
